
import {Component, Prop, Vue, Watch,} from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import AccommodationSelect from "@/components/inputs/AccommodationSelect.vue";
import FeatureAccommodationSelect from "@/components/inputs/FeatureAccommodationSelect.vue";
import AccommodationPriceSelect from "@/components/inputs/AccommodationPriceSelect.vue";
import Budget from '../../models/budget';
import {CambiosAlGuardar, juntar, sinCambios} from '@/helpers/ventana-al-guardar';

@Component({
	components: {
		AccommodationSelect,
		FeatureAccommodationSelect,
		AccommodationPriceSelect,
		ValidationProvider,
		ValidationObserver,
	},
})
export default class TabBudgetAccommodation extends Vue {
	@Prop({ default: null, required: true }) private budget;
	@Prop({ default: null, required: true }) private people;
	@Prop({ default: null, required: false }) private errors;
	// N-287 B: la tarifa tiene que cubrir las fechas del viaje (la regla del funnel).
	@Prop({ default: null, required: false }) private start_date;
	@Prop({ default: null, required: false }) private end_date;
	// N-287 B3: lo que contesta el servidor al GUARDAR si rechaza la tarifa.
	@Prop({ default: () => [], required: false }) private errores_servidor;

	$refs!: {
		obs: InstanceType<typeof ValidationObserver>;
		alojamiento: InstanceType<typeof AccommodationSelect>;
		tarifa: InstanceType<typeof AccommodationPriceSelect>;
	};

	private accommodation_budget: any;
	private increases = {};
	// N-287 B: lo que tenía guardado al abrir (para decirlo si hay que cambiar la tarifa) y los
	// alojamientos con tarifa para este número (para decir cuál sirve si el elegido no).
	private guardado: any = null;
	private alojamientos: any[] = [];

	constructor() {
		super();
		this.accommodation_budget = new Budget();
	}
	mounted() {
		if (this.budget) {
			const accommodation = this.budget.accommodation;
			if (accommodation) {
				this.guardado = {
					accommodation_id: accommodation.id,
					price_id: accommodation.price_id,
					price: accommodation.price,
					// N-288 · T3: con otro régimen, el cambio de precio es del operador.
					feature_id: accommodation.feature_id,
					people_min: accommodation.people_min,
					people_max: accommodation.people_max,
				};
			}
			this.accommodation_budget = Budget.copy(this.budget);
		}
	}

	get erroresAlGuardar() {
		return this.errores_servidor || [];
	}

	setAccommodationIdPricesAndExtras(data) {
		this.accommodation_budget.accommodation.id = data.id;
		this.accommodation_budget.accommodation.name = data.name;
		this.accommodation_budget.accommodation.prices = data.prices;
		this.accommodation_budget.accommodation.extras = data.extras;
	}

	// N-288 · T3: la tarifa que pasó a otro precio y los extras que el tramo nuevo quitó o cambió.
	cambiosAlGuardar(): CambiosAlGuardar {
		return juntar([
			this.$refs.tarifa ? this.$refs.tarifa.cambiosAlGuardar() : sinCambios(),
			this.$refs.alojamiento ? this.$refs.alojamiento.cambiosAlGuardar() : sinCambios(),
		]);
	}

	async validate() {
		this.$emit('input', this.accommodation_budget);
		return await this.$refs.obs.validate();
	}

	setPrice(value){
		if (value) {
			this.accommodation_budget.accommodation.price = value.price;
		}
		let total = 0;
		for (const price of this.accommodation_budget.accommodation.prices) {
			total += price.price;
		}
		for (const extra of this.accommodation_budget.accommodation.extras) {
			total += extra.price;
		}
		total += this.accommodation_budget.accommodation.price;
		this.$emit('setPrice', total);
	}
}
